import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { PlayerAvatar } from "@/components/PlayerAvatar";

/**
 * Vollbild-Willkommens-Moment nach dem Login: großer freigestellter Kopf + Name.
 * Schließt automatisch nach ~4,5s oder per Tap.
 */
export const WelcomeOverlay = ({ name, photoUrl, onClose }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setVisible(false), 4500);
    return () => clearTimeout(t);
  }, []);

  const handleExit = () => onClose && onClose();

  return (
    <AnimatePresence onExitComplete={handleExit}>
      {visible && (
        <motion.div
          key="welcome"
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center cursor-pointer overflow-hidden"
          style={{ background: "radial-gradient(circle at 50% 40%, #3a1420 0%, #12090c 70%)" }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => setVisible(false)}
          data-testid="welcome-overlay"
        >
          {/* Konfetti-artige Glanzpunkte */}
          <div className="pointer-events-none absolute inset-0 opacity-30"
            style={{ backgroundImage: "radial-gradient(rgba(255,255,255,0.4) 1px, transparent 1px)", backgroundSize: "26px 26px" }} />

          <motion.div
            initial={{ scale: 0.4, opacity: 0, y: 40 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            transition={{ type: "spring", stiffness: 200, damping: 16 }}
            className="relative flex flex-col items-center"
          >
            <div className="rounded-full ring-4 ring-rose-500/60 shadow-[0_0_60px_rgba(244,63,94,0.5)]">
              <PlayerAvatar photoUrl={photoUrl} name={name} size="3xl" />
            </div>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.35 }}
              className="mt-8 text-sm uppercase tracking-[0.4em] text-rose-300/70"
            >
              Willkommen
            </motion.p>
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.45 }}
              className="mt-2 text-4xl sm:text-5xl font-black text-white text-center px-6 leading-tight"
              data-testid="welcome-name"
            >
              {name}!
            </motion.h1>
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1.2 }}
              className="mt-8 text-xs text-white/40"
            >
              Tippen zum Fortfahren
            </motion.p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default WelcomeOverlay;
